import { __awaiter, __generator } from "tslib";
import { computed, defineComponent, ref } from 'vue';
import { useAuthStore } from '@/stores/authStore';
import router from '@/routes/index';
import { registerClient } from '@/api/public/client';
import { notify } from '@/utils/toast';
import { toast } from 'vue3-toastify';
import CountrySelect from '@/components/CountrySelect.vue';
export default defineComponent({
    components: {
        CountrySelect: CountrySelect,
    },
    setup: function () {
        var _this = this;
        var register = ref({
            username: '',
            email: '',
            password: '',
            confirmPassword: '',
            country: null,
        });
        var auth = useAuthStore();
        var usernameError = ref('');
        var emailError = ref('');
        var seePass = ref(false);
        var seeRep = ref(false);
        var countries = ref([]);
        var handleRegister = function () { return __awaiter(_this, void 0, void 0, function () {
            var record, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, registerClient(register.value)];
                    case 1:
                        record = _a.sent();
                        console.log(record);
                        if (record.status === 201) {
                            if (auth.hasOrder()) {
                                router.push({ name: 'OrderPage' });
                            }
                            else {
                                router.push({ name: 'Dashboard' });
                            }
                        }
                        else {
                            notify('Ocurrio un error en el registro', 'danger', toast.POSITION.TOP_CENTER);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error('Error al registrar:', error_1);
                        notify('Ocurrio un error en el registro. Fatal error.', 'danger', toast.POSITION.TOP_CENTER);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        var validateEmail = function () {
            var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(register.value.email)) {
                emailError.value = 'Por favor, introduce un correo electrónico válido.';
            }
            else {
                emailError.value = '';
            }
        };
        var validateUsername = function () {
            var usernameRegex = /^[a-zA-Z0-9_.-]+$/; // Permite letras, números, guion bajo, punto y guion medio
            if (!usernameRegex.test(register.value.username)) {
                usernameError.value = 'El nombre de usuario solo puede contener letras, números, guiones bajos, puntos y guiones medios.';
            }
            else if (register.value.username.length < 3) {
                usernameError.value = 'El nombre de usuario debe tener al menos 3 caracteres.';
            }
            else if (register.value.username.length > 20) {
                usernameError.value = 'El nombre de usuario no puede tener más de 20 caracteres.';
            }
            else {
                usernameError.value = '';
            }
        };
        var passwordLevel = computed(function () {
            var value = register.value.password;
            var score = 0;
            if (value.length >= 8)
                score++;
            if (/[A-Z]/.test(value))
                score++;
            if (/[a-z]/.test(value))
                score++;
            if (/\d/.test(value))
                score++;
            if (/[^A-Za-z0-9]/.test(value))
                score++;
            if (score <= 2)
                return 'Bajo';
            if (score === 3)
                return 'Medio';
            if (score === 4)
                return 'Alto';
            return 'Seguro';
        });
        var colorLevel = computed(function () {
            switch (passwordLevel.value) {
                case 'Bajo':
                    return 'red';
                case 'Medio':
                    return 'orange';
                case 'Alto':
                    return 'blue';
                case 'Seguro':
                    return 'green';
                default:
                    return 'gray';
            }
        });
        var enableButton = computed(function () {
            return emailError.value === '' && usernameError.value === '' &&
                register.value.password === register.value.confirmPassword && register.value.password.length > 5;
        });
        return {
            register: register,
            colorLevel: colorLevel,
            passwordLevel: passwordLevel,
            validateEmail: validateEmail,
            validateUsername: validateUsername,
            emailError: emailError,
            usernameError: usernameError,
            enableButton: enableButton,
            countries: countries,
            seePass: seePass,
            seeRep: seeRep,
            handleRegister: handleRegister,
        };
    }
});
